import React, { Component } from 'react';
import QuoteFlowFormLoaderStyles from './QuoteFlowFormLoader';
import moment from 'moment';

export default class QuoteFlowFormLoader extends Component {
  constructor(props){
    super(props);

    const tempLoader = new Image();
    tempLoader.src = "/Assets/images/quote-flow-loading-animation-starting-full.gif";
    if (window.location.href.indexOf("ca/fr") > -1) {
    this.setFRLoaderText();
    }
    else {
    this.setLoaderText();
    }
    this.state = {
      currentHeaderIndex: 0,
      currentCopyIndex: 0,
      removeHeader: false,
      headerAnimationClass: 'animateIn',
      copyAnimationClass: 'animateIn'
    }
    this.animating = false;
  }

  componentDidUpdate() {
    if(( this.props.startAnimating ) && !this.animating ) {
      this.animating = true;
      this.startCyclingCopy();
    }
  }

  startCyclingCopy = ()=> {
    let copyTimer = setInterval( ()=> {
      this.setState( { headerAnimationClass: 'animateOut', copyAnimationClass: 'animateOut' }, ()=> {
        window.setTimeout( ()=> {
          let newHeaderIndex = this.state.currentHeaderIndex + 1;
          let headerIndex =  newHeaderIndex < this.loaderText.headers.length ? newHeaderIndex : 0;

          let newCopyIndex = this.state.currentCopyIndex + 1;
          let copyIndex =  newCopyIndex < this.loaderText.headers.length ? newCopyIndex : 0;

          this.setState( { headerAnimationClass: 'animateBottom', copyAnimationClass: 'animateBottom' }, ()=> {
            window.setTimeout( ()=> {
              this.setState( { currentHeaderIndex: headerIndex, currentCopyIndex: copyIndex }, ()=> {
                this.setState( { headerAnimationClass: 'animateIn', copyAnimationClass: 'animateIn' } );
              });
            }, 250);
          });

          // this.updateCopyTimer();
        }, 1000);
      })

    }, 10000);

    // this.updateCopyTimer();
  }

  updateCopyTimer = ()=> {
    // When there's 2 lines of copy for every header, we need to call this function, but for now it's a one-to-one relationship so not needed
    let copyUpdate = window.setTimeout( ()=> {
      this.setState( { copyAnimationClass: 'animateOut' }, ()=> {
        window.setTimeout( ()=> {
          let newCopyIndex = this.state.currentCopyIndex + 1;
          let copyIndex =  newCopyIndex < this.loaderText.headers.length ? newCopyIndex : 0;

          this.setState( { copyAnimationClass: 'animateBottom' }, ()=> {
            window.setTimeout( ()=> {
              this.setState( { currentCopyIndex: copyIndex }, ()=> {
                this.setState( { copyAnimationClass: 'animateIn' } );
              });
            },250);
          });
        }, 1000);
      });
    }, 10000);
  }

  setLoaderText = ()=> {
    this.loaderText = {
      headers: [
        "This may take up to 30 seconds.",
        "Do-It-Yourself. Or Don't.",
        "Need Multiple Containers?",
        "Pack and Load Like a Pro",
        "Moving and Storage Supplies"
      ],
      copy: [
        "We're searching over 200,000 containers to find you the best price.",
        "We can refer movers to do as much or as little packing and loading as you need.",
        "Order all the containers you need, and have them delivered to different places.",
        "We've got tons of packing and loading tips to help everything go smoothly.",
        "Get fast, free delivery on boxes, blankets, tape, and everything else you need."
      ]
    };
  }
  setFRLoaderText = ()=> {
    this.loaderText = {
      headers: [
        "Cela peut prendre jusqu'a 30 secondes.",
        "Faites-le vous-meme - ou pas.",
        "Besoin de plusieurs conteneurs?",
        "Organiser et charger comme un pro",
        "Fournitures de déménagement/entreposage"
      ],
      copy: [
        "Nous cherchons parmi plus de 200,000 conteneurs pour vous trouver le meilleur prix.",
        "Nous pouvons vous recommander des déménageurs qui ajusteront leurs services à vos besoins.",
        "Commandez tous les conteneurs dont vous avez besoin, et faites-les livrer à différents endroits.",
        "Nous avons des tonnes de conseils d'expert pour organiser et charger votre conteneur en un tournemain.",
        "Obtenez des boîtes, couvertures, ruban adhésif et tout le reste rapidement et gratuitement."
      ]
    };
  }

  render() {
    return (
      <div id="LoadingScreen" className="quoteFlow__Loader">
        <div className="quoteFlow__Loader-innerholder">
          <img src="/Assets/images/quote-flow-loading-animation-starting-full.gif" />
          <div className="quoteFlow__loader-copy-holder quoteFlow__loader-header-holder">
            <h2 className={ this.state.headerAnimationClass } dangerouslySetInnerHTML={{ __html:  this.loaderText.headers[this.state.currentHeaderIndex] } }></h2>
            <h2 className="hidden_header" dangerouslySetInnerHTML={{ __html:  this.loaderText.headers[this.state.currentHeaderIndex] } }></h2>
          </div>
          <div className="quoteFlow__loader-copy-holder">
            <h3 className={ this.state.copyAnimationClass } dangerouslySetInnerHTML={{ __html:  this.loaderText.copy[this.state.currentCopyIndex] } }></h3>
            <h3 className="hidden_header" dangerouslySetInnerHTML={{ __html:  this.loaderText.copy[this.state.currentCopyIndex] } }></h3>
          </div>
        </div>
      </div>
    )
  }
}
